module.exports = __webpack_public_path__ + "static/fun-time/games/page000_game2/audio//1_hello.mp3";